
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1afi9_96if7_145",
  "hidden": "awsui_hidden_1afi9_96if7_176",
  "no-items": "awsui_no-items_1afi9_96if7_179"
};
  